import { type ReactElement } from 'react';
import { Link } from 'react-router';
import RecipeaseLogo from './RecipeaseLogo';

function Footer(): ReactElement {
	return (
		<footer className='site-footer'>
			<div className='site-footer__bar container caption'>
				<span className='site-footer__brand'>
					<RecipeaseLogo wordmark={false} />
					<span>
						&copy; 2026 Recipease &middot;{' '}
						<a href='https://scottmallinson.com' target='_blank' rel='me noopener noreferrer'>
							Scott Mallinson
						</a>
					</span>
				</span>
				<nav className='site-footer__links' aria-label='Footer'>
					<Link to='/pricing'>Pricing</Link>
					<Link to='/recipes/import'>Import a recipe</Link>
				</nav>
			</div>
		</footer>
	);
}

export default Footer;
